export default {
      id: "icon--chevron-curvy-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--chevron-curvy-usage",
      toString: function () {
        return this.url;
      }
    }